import { render } from "./DeptBoardDetail.vue?vue&type=template&id=78d96444"
import script from "./DeptBoardDetail.vue?vue&type=script&lang=js"
export * from "./DeptBoardDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__